import React from "react";
import { priceFormat } from "@/utils/common";
import { renderCouponLabel } from "../renderCouponLabel";
import { processDescText } from "../../utils";
import "./index.less";
import { GoodsItem } from "@/pages/charge-vip/types";
import { processOssImage } from "@/utils/image";

export interface SmallGoodsItemWithBuyProps {
  goodItem: GoodsItem;
  doBuyMemberGoods: (item: GoodsItem) => void;
  index: number;
  isDiscount: boolean;
  showCreditPrice: boolean;
  countdown?: string;
}

export const SmallGoodsItemWithBuy: React.FC<SmallGoodsItemWithBuyProps> = ({
  goodItem,
  doBuyMemberGoods,
  index,
  isDiscount,
  showCreditPrice,
  countdown
}) => {
  return (
    <div
      className={`small-good-item-with-buy`}
      onClick={() => {
        if (goodItem?.soldOut) return;
        doBuyMemberGoods(goodItem);
      }}
      key={`good-${goodItem?.skuId}-${index}`}
    >
      {!goodItem?.soldOut && renderCouponLabel({
        couponLabel: goodItem?.actDiscountLabel,
        discountType: goodItem?.discountType,
        countdown,
      })}

      <div className="good-title">{goodItem?.name || "--"}</div>

      {goodItem?.customPicture ? (
        <img
          className="good-img"
          src={processOssImage(goodItem?.customPicture)}
          alt={goodItem?.name || "--"}
        />
      ) : (
        <div className="good-extra">
          {processDescText(goodItem?.desc).map((line: string, idx: number, array) => (
            <React.Fragment key={idx}>
              {line}
              {idx < array.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      )}

      <div className="good-buy-wrap">
        {goodItem?.discountType === "COUPON_PRICE" &&
          goodItem?.discountBuyPrice !== null && !goodItem?.soldOut && (
            <div className="good-redpack">
              红包已减
              {priceFormat(goodItem?.salePrice - goodItem?.discountBuyPrice)}元
            </div>
          )}
        {goodItem?.soldOut ? (
          <div className="good-buy-btn sold-out-btn" style={{ color: '#fff', alignItems: 'center' }}>
            商品已售罄
          </div>
        ) : (
          <div className="good-buy-btn">
            <span className="good-price">
              <span className="big-heavy-text-unit">¥</span>
              <span className="big-heavy-text">
                {priceFormat(
                  isDiscount ? goodItem?.discountBuyPrice : goodItem?.salePrice,
                )}
              </span>
            </span>
            <div className="good-price-wrap">
              <span className="good-line-price">
                {isDiscount && `¥${priceFormat(goodItem?.salePrice)}`}
              </span>
              {goodItem?.maxUseCreditAmount && showCreditPrice && (
                <div className="good-points-price">
                  积分价：{goodItem?.maxUseCreditAmount}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
